<div class="dialog-close" (click)="dialogRef.close()">
  <h1 mat-dialog-title>Editor</h1>
</div>



<div id="edit-dialog" mat-dialog-content>
  <div [froalaEditor]="options" [(froalaModel)]="content" ></div>
</div>

<div mat-dialog-actions class="ui-layout cab-change-bottom" ui-layout-align="end">
  <div class="ui-layout-row autotranslate-info margin-b-25 align-center" [ngClass]="{'content-hidden': !autotranslate}">
    <img src="assets/svg/symbols.svg" alt="">
    <span class="description">The simulation will be translated using machine translation</span>
  </div>
  <div class="dialog-actions">
    <div class="ui-layout-column">
      <div class="ui-layout-row align-center edit-languages-container">
        <mat-checkbox class="dashboard-checkbox"
          [(ngModel)]="autotranslate"
          name="autotranslate"
          color="primary">
          Auto-translate text to your relevant languages
        </mat-checkbox>
        <button mat-button
          type="button"
          class="edit-languages-btn"
          (click)="openEditLanguagesDialog()"
          [disabled]="!autotranslate">
          <img src="assets/svg/edit.svg" alt="Edit languages" class="edit-icon">
          Edit languages
        </button>
      </div>
      @if (error) {
        <div class="dialog-error">
          <span ><img alt="Attention sign" src="/assets/svg/attention_sign.svg"/>{{ error }}</span>
        </div>
      }
    </div>
    <div>
      <button (click)="onClickRestore()" class="dashboard-button action" [disabled]="!isReplacement">Restore</button>
      <button mat-button (click)="onClickSave()" [disabled]="!canSave" class="dashboard-button confirm focused">Save
        @if (autotranslate) {
          & Translate
        }
      </button>
    </div>
  </div>
</div>
